namespace GeniuzPOS.Inventory {
    export interface IcStockReturnOutData extends Serenity.ListRequest {
        Header?: IcStockReturnOutRow;
        Details?: IcStockReturnOutDtRow[];
        SysDocNo?: string;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
